<template>
  <view-page
      :baseRoute='baseRoute'
      :entity='entity'
      :button-access="componentAccess"
      :model-entity="modelEntity"
      :page-title="setPageTitle"
      :showLoading="false"
  >

    <template v-slot="{ model }">
      <product-bundle-form
          v-if="model"
          readonly
          v-model="model"
          card-title="View Product Bundle"
      />
    </template>
  </view-page>
</template>

<script>

import ProductBundleForm from "@/views/pages/product-bundles/ProductBundleForm";
import ViewPage from "@/views/components/Views/ViewPage";
import EnablePublishMixin from '../../../components/mixins/EnablePublishMixin';
import NotificationMixin from '../../../components/mixins/NotificationMixin';

export default {
  name: "ProductBundleDetails",
  components: {
    ProductBundleForm,
    ViewPage,
  },
  mixins: [NotificationMixin, EnablePublishMixin],
  data() {
    return {
      baseRoute: 'product-bundles',
      entity: 'Product Bundle',
      modelEntity: this.$api.productBundles,
      title: '',
      componentAccess: {
        canEdit: {
          route: 'product-bundles.edit',
          access: false,
        },
        canDelete: {
          route: 'falsebaseRoute',
          access: false,
        },
      }
    };
  },
  methods: {
    setPageTitle(params) {
      if (!params.ProductCode) {
        return '';
      }

      return "Product Bundle: " + params.ProductCode;
    }
  }
};
</script>

<style scoped>

</style>
